/**!
 *
 * Copyright (c) 2015-2017 Cisco Systems, Inc. See LICENSE file.
 * @private
 */

export default {
  avatar: {
    batcherWait: 100,
    batcherMaxCalls: 100,
    batcherMaxWait: 1500,

    /**
     * @description avatar URL store TTL, allows avatar updates to eventually be propegated
     * @type {number} Number of seconds the avatar should remain in store
     */
    cacheControl: 60 * 60,
    /**
     * @description default avatar size to retrieve if no size is specified
     * @type {number}
     */
    defaultAvatarSize: 80
  }
};
